import { Dispatch, SetStateAction } from 'react';
import { createCtx } from '../createCtx';

export type Orientation = 'landscape' | 'portrait';
export type Layout = 'desktop' | 'phone';
export type UiContext = {
    isDarkmode: boolean;
    isTeams: boolean;
    isInIframe: boolean;
    isInModelDrivenApp: boolean;
    isInPhoneMode: boolean;
    isInDesktopMode: boolean;
    showNavbar: boolean;
    setShowNavbar: Dispatch<SetStateAction<boolean>>;
    layout: Layout;
    orientation: Orientation;
};
export const [useUiContext, Provider] = createCtx<UiContext>();
export const darkmodeMediaMatch = window.matchMedia('(prefers-color-scheme: dark)');
export const mediaQueryDesktop = window.matchMedia('(min-width: 500px)');
export const mediaQueryOrientationLandscape = window.matchMedia('(orientation: landscape)');
export const isInIframe = window.location !== window.parent.location;
export const isTeams =
    window.location.ancestorOrigins !== undefined &&
    window.location.ancestorOrigins.length >= 1 &&
    window.location.ancestorOrigins[0] === 'https://teams.microsoft.com';
export const isInModelDrivenAppContext = isInIframe && !isTeams;
